<template>
  <div id="app">
    <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <!-- <router-view></router-view> -->
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
.size {
  width: 100%;
  height: 100%;
}
html,
body {
  .size;
  overflow: hidden;
  margin: 0;
  padding: 0;
}
#app {
  .size;
}
.template {
  .search {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #f0f0f0;
    padding: 0px 0px 20px;
    .search-center {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .search-item {
        margin-right: 20px;
        margin-bottom: 5px;
        display: flex;
        align-items: center;
      }
    }
  }
  .filter {
    width: 100%;
    display: flex;
    align-items: center;
    padding: 20px 0px;
    justify-content: space-between;
    .filter-center {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .filter-item {
        margin-right: 20px;
        display: flex;
        margin-bottom: 5px;
        align-items: center;
      }
    }
  }
.ivu-table,.ivu-tag{
font-size: 14px !important;
}

  .table {
    margin-top: 10px;
    border-bottom: 1px solid #e8eaec;
  }
  .ivu-table-wrapper {
    border: none !important;
  }
  .ivu-table:after,
  .ivu-table:before {
    background-color: #fff !important;
  }
}
.upload-Img {
  width: 100%;
  display: flex;
  align-items: center;

  .upload-btn {
    width: 100px;
    height: 100px;
    border: 1.5px dashed #ddd;
    text-align: center;
    margin: 0 auto;
    padding-top: 10px;
    border-radius: 5px;
    cursor: pointer;
  }
  .look-img {
    display: flex;
    align-items: center;
    width: 100px;
    height: 100px;
    border: 1px dashed rgba(197, 197, 197, 1);
    text-align: center;
    justify-content: space-evenly;
    position: relative;
    overflow: hidden;
    margin-left: 10px;
  }

  .demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    text-align: center;
  }

  .look-img:hover .demo-upload-list-cover {
    display: block;
  }

  .demo-upload-list-cover i {
    line-height: 98px;
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }

  .demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
  }
}
.footer {
  width: 100%;
  margin-top: 20px;
}
.pdR40{
  padding-right: 40px;
}
.ivu-form-item-content{
  font-size: 14px !important;
}

.effect{
  .title{
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 20.27px;
    color: rgba(0, 0, 0, 1);
    text-align: left;
    vertical-align: top;
  }
  .effect-center{
      width: 357px;
      height: 653px;
  }
}
.ivu-modal-mask,.ivu-modal-wrap{
  z-index: 99999 !important;
}
</style>
